import { thunk, action } from 'easy-peasy'
import _ from 'lodash'

import { getIncidentListApi } from 'services/monthlyDashboard'
import { getRiskMatrixApi } from 'services/riskMatrix'
import { getValueListApi, getValueListTypeApi } from 'services/value_list'
import { getRiskLevelDashboard } from 'services/dashboard/riskLevel'
import { getIncidentDashboard } from 'services/dashboard/incident'
import { getMonthlyReviewListApi } from 'services/monthlyReview'
import { getReportTypeAttributeListApi, getReportTypeAttributeReportTypeListApi } from 'services/reportType/attribute'
// State
const initialState = {
  incidentDashboard: {
    items: [],
  },
  incidentChart: {
    data: {
      weekly: [],
      monthly: [],
      quarterly: [],
      yearly: [],
    },
    key: [],
  },
  loading: false,
  reportNumberAttrSelector: [],
  reportAttribute: [],
  attrNumberType: [],
  periodSelector: [],
  riskMatrixList: {
    items: [],
  },
  riskMatrixSelectedList: {
    items: [],
  },
  monthlyReviewList: {
    items: [],
  },
  riskMatrixChartData: [],
  impactLevelSelector: [],
  reportMatrixValue: [],
  riskMatrixFilters: {
    // reporter_company_id: ,
    // risk_co_company_id: null,
    // risk_owner_company_id: null,
    // date_from: null,
    // date_to: null,
    // report_status_id: null,
    page: 1,
    size: 10,
  },
  riskMatrixChartFilters: {
    page: 1,
    size: 10,
    // Default impact_type_id to ภาพรวมผลกระทบ
    impact_type_id: 50
  },
  incidentDashboardFilters: {
    // reporter_company_id: null,
    // risk_co_company_id: null,
    // risk_owner_company_id: null,
    // date_from: null,
    // date_to: null,
    // report_status_id: null,
    // report_type_id: null,
    page: 1,
    size: 10,
  },
  monthlyReviewFilters: {
    page: 1,
    size: 10,
  },
  icPeriodFilter: 'monthly',
  icDateFilters: [],
  icReportTypeNumberFilters: [],
  icRemoveIncidentFilters: [],
}
// Actions
const actions = {
  setIncidentDashboard: action((state, payload) => {
    state.incidentDashboard = payload
  }),
  setReportNumberAttrSelector: action((state, payload) => {
    state.reportNumberAttrSelector = payload
  }),
  setLoading: action((state, payload) => {
    state.loading = payload
  }),
  setAttrNumberType: action((state, payload) => {
    state.attrNumberType = payload
  }),
  setPeriodSelector: action((state, payload) => {
    state.periodSelector = payload
  }),
  setReportAttribute: action((state, payload) => {
    state.reportAttribute = payload
  }),
  setRiskMatrixList: action((state, payload) => {
    state.riskMatrixList = payload
  }),
  setMonthlyReviewList: action((state, payload) => {
    state.monthlyReviewList = payload
  }),
  setImpactLevelSelect: action((state, payload) => {
    state.impactLevelSelector = payload
  }),
  setReportMatrixValue: action((state, payload) => {
    state.reportMatrixValue = payload
  }),
  setRiskMatrixSelectedList: action((state, payload) => {
    state.riskMatrixSelectedList = payload
  }),
  setRiskMatrixChartData: action((state, payload) => {
    state.riskMatrixChartData = payload
  }),
  setIncidentChart: action((state, payload) => {
    state.incidentChart = payload
  }),
  setRiskMatrixFilters: action((state, payload) => {
    state.riskMatrixFilters = payload
  }),
  setRiskMatrixChartFilters: action((state, payload) => {
    state.riskMatrixChartFilters = payload
  }),
  setIncidentDashboardFilters: action((state, payload) => {
    state.incidentDashboardFilters = payload
  }),
  setMonthlyReviewFilters: action((state, payload) => {
    state.monthlyReviewFilters = payload
  }),
  setIcPeriodFilters: action((state, payload) => {
    state.icPeriodFilter = payload
  }),
  setIcDateFilters: action((state, payload) => {
    state.icDateFilters = payload
  }),
  setIcReportTypeNumberFilters: action((state, payload) => {
    state.icReportTypeNumberFilters = payload
  }),
  setIcRemoveIncidentFilters: action((state, payload) => {
    state.icRemoveIncidentFilters = payload
  }),
}

// Thunks
const thunks = {
  getIncidentDashboardThunk: thunk(async (actions, payload, { getState }) => {
    actions.setLoading(true)
    const getIncidentDashBoardParams = {...payload}
    getIncidentDashBoardParams.start_date = getIncidentDashBoardParams.date_from;
    getIncidentDashBoardParams.end_date = getIncidentDashBoardParams.date_to;
    getIncidentDashBoardParams.date_from = '';
    getIncidentDashBoardParams.date_to = '';
    const [list, chart] = await Promise.all([
      getIncidentListApi(payload),
      getIncidentDashboard(getIncidentDashBoardParams),
    ])
    if (list.status === 'success' && !_.isEmpty(list.data)) {
      actions.setIncidentDashboard(list.data)
    }

    if (chart.status === 'success' && !_.isEmpty(chart.data)) {
      actions.setIncidentChart(chart.data)
    }
    actions.setLoading(false)
  }),
  getIncidentChartThunk: thunk(async (actions,payload) => {
    actions.setLoading(true)
    const getIncidentDashBoardParams = {...payload}
    getIncidentDashBoardParams.start_date = getIncidentDashBoardParams.date_from;
    getIncidentDashBoardParams.end_date = getIncidentDashBoardParams.date_to;
    getIncidentDashBoardParams.date_from = '';
    getIncidentDashBoardParams.date_to = '';
    const chart = await getIncidentDashboard(getIncidentDashBoardParams)
    if (chart.status === 'success' && !_.isEmpty(chart.data)) {
      actions.setIncidentChart(chart.data)
    }
    actions.setLoading(false)
  }),
  getReportDataTypeThunk: thunk(async (actions, payload, { getStoreState }) => {
    const { dataTypes } = getStoreState().filter
    const numberType = dataTypes
      .filter((item) => ['integer', 'float'].includes(item.name))
      .map((item) => item.id)
    actions.setAttrNumberType(numberType)
    const { status, data } = await getReportTypeAttributeReportTypeListApi({ report_type_id: payload })
    if (status === 'success' && !_.isEmpty(data)) {
      actions.setReportAttribute(
        _(data.items)
          .filter((item) => item.is_dashboard)
          .orderBy('report_order')
          .map((item) => {
            return {
              label: item.report_type_attribute_name,
              value: item.report_type_attribute_id,
            }
          })
      )
    }
  }),
  getRiskMatrixListThunk: thunk(async (actions, payload) => {
    actions.setLoading(true)
    const [list, chart] = await Promise.all([
      getIncidentListApi(payload),
      getRiskLevelDashboard(payload),
    ])
    if (list.status === 'success' && !_.isEmpty(list.data)) {
      actions.setRiskMatrixList(list.data)
    }
    if (chart.status === 'success' && !_.isEmpty(chart.data)) {
      actions.setRiskMatrixChartData(chart.data)
    }
    actions.setLoading(false)
  }),
  getImpactSelectorThunk: thunk(async (actions) => {
    const valueListType = await getValueListTypeApi()
    const targetType = _.find(valueListType.data, (item) => item.value_list_type_code === 'IPT')
    const impactLevelList = await getValueListApi(targetType?.value_list_type_id)
    const formatImpactLevel = _.map(impactLevelList.data, (item) => {
      return { label: item.name, value: item.id }
    })
    actions.setImpactLevelSelect(formatImpactLevel)
  }),
  getReportMatrixValueThunk: thunk(async (actions, payload) => {
    actions.setLoading(true)
    const res = await getRiskMatrixApi(payload, { param: undefined, is_active: undefined })
    if (res.status === 'success') {
      // const data = _.sortBy(res.data, ["likelihood_score","impact_score"])
      const data = _.orderBy(res.data, ['impact_score', 'likelihood_score'], ['desc'])
      actions.setReportMatrixValue(data)
    }
    actions.setLoading(false)
  }),
  getRiskMatrixSelectedListValueThunk: thunk(async (actions, payload, { getState }) => {
    const { riskMatrixFilters, riskMatrixChartFilters } = getState()
    actions.setLoading(true)
    const res = await getIncidentListApi({
      ...riskMatrixFilters,
      ...riskMatrixChartFilters,
    })
    if (res.status === 'success') {
      // const data = _.sortBy(res.data, ["likelihood_score","impact_score"])
      actions.setRiskMatrixSelectedList(res.data)
    }
    actions.setLoading(false)
  }),
  // Monthly Review
  getMonthlyReviewThunk: thunk(async (actions, payload, { getState }) => {
    const { monthlyReviewFilters } = getState()
    const { setLoading, setMonthlyReviewList } = actions

    //console.log('payload' + JSON.stringify({...monthlyReviewFilters}, null, " "))
    
    setLoading(true)
    const { status, data } = await getMonthlyReviewListApi({ ...monthlyReviewFilters })
    // console.log('status' + JSON.stringify(res))
    if (status === 'success') {
      setMonthlyReviewList(data)
    }
    setLoading(false)
  }),
}

const model = {
  ...initialState,
  ...actions,
  ...thunks,
}

export default model
